import { FunctionComponent } from 'react';
import {
    FormControl,
    InputAdornment,
    InputLabel,
    FilledInput,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

type LiftOperatorSearchFieldProps = {
    value: string;
    onChange: (value: string) => void;
};

export const LiftOperatorFormSearchField: FunctionComponent<
    LiftOperatorSearchFieldProps
> = ({ value, onChange }) => {
    return (
        <FormControl variant='filled' fullWidth>
            <InputLabel>Felder durchsuchen</InputLabel>
            <FilledInput
                fullWidth
                size='small'
                value={value}
                onChange={(e) => onChange(e.target.value)}
                startAdornment={
                    <InputAdornment position='start'>
                        <SearchIcon />
                    </InputAdornment>
                }
            />
        </FormControl>
    );
};
